import React, {useState, useEffect, useRef} from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Navbar.css';
import { IoIosArrowDown } from 'react-icons/io';
import { getUnderNavIcon } from './PictoIcons';

function getWindowSize() {
    const {innerWidth, innerHeight} = window;
    return {innerWidth, innerHeight};
}

function Navbar({elements, setShowPage}) {
    const [windowSize, setWindowSize] = useState(getWindowSize()); // taille de la fenêtre
    const navigate = useNavigate(); // Utiliser pour les redirections
    const location = useLocation();
    // Section courante (ex: "proam" pour /proam/classement) => onglet actif
    const currentSection = location.pathname.split('/')[1];
    const [, setCurrentUnderNav] = useState(null); // Contient la seconde navbar en cours7
    const [currentUnderNavIndex, setCurrentUnderNavIndex] = useState(0);
    const [, setCurrentRedireciton] = useState("");
    const [showNavbar, setShowNavbar] = useState(true);
    const [alreadyHided, setAlreadyHided] = useState(false);

    const [currentHover, setCurrentHover] = useState(0);
    const [showUnderNav, setShowUnderNav] = useState(false);

    // Horodatage du dernier appui tactile : sert à ignorer le mouseenter
    // « fantôme » que les navigateurs mobiles émettent juste après un tap
    // (sinon il rouvre aussitôt le sous-menu qu'on vient de refermer).
    const lastTouchTime = useRef(0);

    useEffect(() => {
        if (windowSize.innerWidth > 1000) {
            handleNavbar(true);
            setAlreadyHided(false);
        }
        else {
            if (!alreadyHided) {
                handleNavbar(false)
                setAlreadyHided(true);
            }
        }
    }, [windowSize])

    useEffect(() => {

        const handleWindowResize = () => {
            setWindowSize(getWindowSize());
        }

        // à l'apparition de la page
        handleWindowResize();
    
        window.addEventListener('resize', handleWindowResize);
    
        return () => {
          window.removeEventListener('resize', handleWindowResize);
        };
      }, []);

    // Fonction qui vérifie si l'élement sous la souris
    // doit fait afficher une seconde navbar ou non
    const checkUnderNav = (event, underNav, redirectionVar, index) => {
        event.preventDefault();

        const isTouch = event.type === 'touchend';
        // Menu vertical (mobile / petite fenêtre) : il s'utilise au clic ou au doigt.
        // Au survol de la souris, on ne fait rien : sinon survoler une entrée sans
        // sous-menu (ex: ACTUALITES) redirigeait aussitôt et refermait le menu.
        const isClick = isTouch || event.type === 'click';
        if (!isClick && windowSize.innerWidth <= 1000) {
            return;
        }

        if (isClick) {
            if (isTouch) {
                lastTouchTime.current = Date.now();
            } else if (Date.now() - lastTouchTime.current < 800) {
                // clic émis par le navigateur juste après un tap (déjà traité
                // au touchend) => on l'ignore, sinon la bascule s'annule.
                return;
            }
            // Un second appui sur un onglet déjà déroulé referme
            // son sous-menu (comportement bascule).
            if (underNav !== null && currentUnderNavIndex === index) {
                setShowUnderNav(false);
                setCurrentUnderNav(null);
                setCurrentUnderNavIndex(0);
                setCurrentRedireciton("");
                setCurrentHover(0);
                return;
            }
        } else if (Date.now() - lastTouchTime.current < 800) {
            // mouseenter fantôme émis juste après un tap => on l'ignore,
            // sinon il annule la bascule qu'on vient de faire.
            return;
        }

        setCurrentHover(index)
        if (underNav !== null) {
            // on sauvegarde la redirection de cet item
            // pour la réutiliser dans la seconde navbar
            setCurrentRedireciton(redirectionVar)
            setCurrentUnderNavIndex(index)
            // underNav = {elements2} ou underNav = null
            setCurrentUnderNav(underNav)
            setShowUnderNav(true);
        }
        else {
            mouseLeaveNavbar();
            // responsive redirection
            if (windowSize.innerWidth <= 1000) {
                redirection(redirectionVar);
            }
        }
    }
    
    // redirection
    const redirection = (redirection) => {
        if (redirection === "/livescoring") {
            window.open("https://www.fftt.com/livescoring", "_blank");
        }
        else if (redirection !== "") {
            if (windowSize.innerWidth <= 1000) {
                handleNavbar(false);
            }
            navigate(redirection);
        }
    }

    const handleNavbar = (value) => {
        if (windowSize.innerWidth <= 1000 && value) {
            setShowPage(false);
        }
        else {
            setShowPage(true);
        }
        if (!value) {
            setCurrentUnderNav(null);
            setCurrentUnderNavIndex(0);
            setCurrentRedireciton("");
        }
        setShowNavbar(value);
    }

    // Classes d'état d'un onglet : sous-menu déroulé (is-open) et section courante (is-active)
    const getTopSpanClass = (item) => {
        let className = "navbar_span_top " + item.short;
        const isMobile = windowSize.innerWidth <= 1000;
        if (item.underNav !== null && currentUnderNavIndex === item.id && (isMobile || currentHover === item.id)) {
            className += " is-open";
        }
        const section = item.underNav !== null ? item.short : item.redirection.split('/')[1];
        if (section && section === currentSection) {
            className += " is-active";
        }
        return className;
    }

    const mouseLeaveNavbar = () => {
        setShowUnderNav(false);
        setCurrentHover(0);
    }

    return (
        <div className="navbar_component" onMouseLeave={()=>mouseLeaveNavbar()}>
            <button type="button" className={"navbar_menu" + (showNavbar ? " is-open" : "")} onClick={()=>handleNavbar(!showNavbar)} aria-label={showNavbar ? "Fermer le menu" : "Ouvrir le menu"} aria-expanded={showNavbar}>
                <span className="navbar_menu-bar"></span>
                <span className="navbar_menu-bar"></span>
                <span className="navbar_menu-bar"></span>
            </button>
            {
                showNavbar
                &&
                <nav id="firstNav" className="navbar_row">
                    {/* On affiche tous les onglets */}
                    {
                        elements.map((item, index) => {
                            return (
                                <div key={index} className="span_container">
                                    <span className={getTopSpanClass(item)} onTouchEnd={(e)=>checkUnderNav(e,item.underNav,item.redirection,item.id)} onMouseEnter={(e)=>checkUnderNav(e,item.underNav,item.redirection,item.id)} onClick={(e)=>windowSize.innerWidth <= 1000 ? checkUnderNav(e,item.underNav,item.redirection,item.id) : redirection(item.redirection)}>
                                        {item.title}
                                        {
                                            item.underNav !== null &&
                                            <IoIosArrowDown className="navbar_chevron" size={14} />
                                        }
                                    </span>
                                    {
                                        (item.underNav !== null && currentUnderNavIndex === item.id &&
                                        (windowSize.innerWidth <= 1000 || showUnderNav))
                                        &&
                                        <div className={"navbar_undernav " + item.short}>
                                            {
                                                item.underNav.map((underItem) => {
                                                    return (
                                                        <span className={"navbar_span undernav " + item.short + (location.pathname === "/" + item.short + underItem.redirection ? " is-active" : "")} key={underItem.id} onClick={()=>redirection("/" + item.short + underItem.redirection)}>
                                                            {getUnderNavIcon(underItem.title)}
                                                            {underItem.title}
                                                        </span>
                                                    )
                                                })
                                            }
                                        </div>
                                    }
                                </div>
                            )
                        })
                    }

                </nav>
            }
        </div>
    );
}

export default Navbar;